module.exports = __webpack_public_path__ + "img/matri1.bc11be04.jpg";